import { IPaymentDetails } from '../../models';

interface ContactInfoFormDefaultValues {
  paymentInfo_iban: string | null;
  paymentInfo_oban: string | null;
  paymentInfo_iban_oban_selection: string | null;
  paymentInfo_accountHolder: string | null;
  paymentInfo_bic: string | null;
}

export function handlePaymentDetailsFormDefaultValues(
  payment_details: IPaymentDetails
): ContactInfoFormDefaultValues {
  return {
    paymentInfo_iban: payment_details.iban,
    paymentInfo_oban: payment_details.oban,
    paymentInfo_iban_oban_selection:
      payment_details.oban === null ? 'IBAN' : 'OBAN',
    paymentInfo_accountHolder: payment_details.account_holder,
    paymentInfo_bic: payment_details.bic,
  };
}
